import type { FaireProductEntity } from "../../entity_types/product";

export const p_qxjv478msj: FaireProductEntity = {
  token: "p_qxjv478msj",
  type: "product",
  name: "BIG Problem",
  brandToken: "b_ebwob1e8ry",
  brandName: "Carson Dellosa Education",
  imageUrl:
    "https://cdn.faire.com/fastly/ab98d639aca1399ff7290251848863e27f51cd76344e750eb69e81aad802fd47.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.8,
  description:
    "When Piglet arrives at Rescue Ranch, Remy and Ruby are expecting a baby pig. But Piglet isn't a piglet at all. She is BIG! And she can make some BIG messes. Can Ruby and Remy figure out how to handle this BIG problem? --The Remy and Ruby's Rescue Ranch series features Remy and Ruby's adventures on their family's ranch, which is a hybrid of a typical ranch and a wildlife rescue facility. The primary focus of this series is to encourage reading for pleasure, with animal facts woven into the dialogue. Back matter includes information on animals featured in the story.",
  tags: [],
  msrpDollars: 31.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:18.213Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
